import { render, staticRenderFns } from "./detailHandoverSales.vue?vue&type=template&id=39c5c182&"
import script from "./detailHandoverSales.vue?vue&type=script&lang=js&"
export * from "./detailHandoverSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports